/** Bluprise service capabilities. Package links apply where a matching plan exists. */

export const CAPABILITIES = [
  {
    "id": "web-app-builds",
    "title": "Websites",
    "line": "Business websites, stores and web apps built to work.",
    "bullets": [
      "Responsive design and clear journeys from first visit to enquiry",
      "E-commerce, accounts, payments and customer dashboards",
      "Hosting, monitoring and ongoing support"
    ],
    "planId": "site-devops"
  },
  {
    "id": "seo",
    "title": "SEO",
    "line": "Make your business easier to find in search.",
    "bullets": [
      "Technical audits, indexing and site performance improvements",
      "Search-focused page structure, content and on-page optimization",
      "Local SEO and reporting tied to enquiries and conversions"
    ],
    "planId": "site-seo"
  },
  {
    "id": "ai",
    "title": "AI",
    "line": "Put AI to work inside your products and processes.",
    "bullets": [
      "AI assistants, search and document workflows",
      "Integration with your business data and existing tools",
      "Evaluation and monitoring for the tasks that matter to your team"
    ],
    "planId": null
  },
  {
    "id": "api-integrations",
    "title": "API Integrations",
    "line": "Connect your tools, data and customer journeys.",
    "bullets": [
      "CRM, payments, booking and third-party API connections",
      "Webhooks, data sync and reliable error handling",
      "Custom APIs with authentication and clear documentation"
    ],
    "planId": null
  },
  {
    "id": "ai-agents",
    "title": "AGI Bots",
    "line": "Custom AI agents that carry out multi-step business workflows.",
    "bullets": [
      "Agents for research, support and repetitive operations",
      "Tool access and approval steps for actions that need oversight",
      "Workflow automation, monitoring and human handoffs"
    ],
    "planId": "hermes"
  },
  {
    "id": "travel-tech",
    "title": "Travel Tech",
    "line": "Booking platforms and connected travel operations.",
    "bullets": [
      "Hotel booking experiences for travelers, events and business trips",
      "Supplier API connections, availability and payment flows",
      "Booking management and customer portals, informed by our own BluBeds platform"
    ],
    "planId": null
  },
];
